export type Tip = { icon: string; text: string };

/**
 * Curated "tip of the hour" set, a mix of feature discovery, reading habits,
 * and what makes InSnip different. Shown at the round-summary pause so it nudges
 * deeper use without interrupting reading. Keep each tip to one short sentence.
 */
export const TIPS: Tip[] = [
  { icon: "⚡", text: "React to stories you like, and InSnip quietly tunes tomorrow's feed toward them." },
  { icon: "🔖", text: "Save a card to finish later; your saves live under the bookmark filter." },
  { icon: "👆", text: 'Swipe up or tap "Uncover more" to read the full story behind a snippet.' },
  { icon: "🎧", text: "In a rush? Hit Listen and InSnip reads the card aloud, hands-free." },
  { icon: "🧭", text: "Use the topic chips to jump straight to Finance, AI, Politics and more." },
  { icon: "🔗", text: 'Every card shows its sources; tap "Sources" to read the original reporting.' },
  { icon: "🌙", text: "Reading at night? Press T to switch to an easier-on-the-eyes theme." },
  { icon: "📅", text: "InSnip refreshes through the day, so reopen later and pick up at the next new card." },
  { icon: "🖼️", text: 'Found a gem? "Image" turns any card into a shareable picture.' },
  { icon: "🔥", text: "Finish a round of 10 each day to keep your reading streak alive." },
  { icon: "🇦🇺", text: "InSnip leans Australian-first, then the world, with local context and less noise." },
  { icon: "✅", text: 'The "Original" badge means the snippet is freshly synthesised, never copied.' },
];

/**
 * Deterministic tip for a given moment. Rotates every hour so a reader who comes
 * back later sees something new, while everyone in the same hour sees the same
 * tip (stable, cache-friendly, no backend). Pure + testable.
 */
export function tipForHour(now: Date = new Date(), tips: Tip[] = TIPS): Tip {
  if (tips.length === 0) return { icon: "💡", text: "" };
  const hours = Math.floor(now.getTime() / 3_600_000);
  const index = ((hours % tips.length) + tips.length) % tips.length;
  return tips[index];
}
